import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class UniversityInterceptor implements HttpInterceptor {
	constructor(
	) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		const isUniversityApiUrl = request.url.startsWith(`${environment.apiUrl}${environment.apiUniversityUrl}`);
		const isSchoolApiUrl = request.url.startsWith(`${environment.apiUrl}${environment.apiSchoolUrl}`);

		// Un header già impostato esplicitamente (e non vuoto) dal service vince sul valore in sessionStorage
		const setHeaders: { [name: string]: string } = {};

		if (sessionStorage.getItem('university') && isUniversityApiUrl) {
			if (!request.headers.get('X-University')) {
				setHeaders['X-University'] = sessionStorage.getItem('university')!;
			}
		} else if (sessionStorage.getItem('school') && isSchoolApiUrl) {
			if (!request.headers.get('X-University') && sessionStorage.getItem('university')) {
				setHeaders['X-University'] = sessionStorage.getItem('university')!;
			}
			if (!request.headers.get('X-SchoolUniversity')) {
				setHeaders['X-SchoolUniversity'] = sessionStorage.getItem('school')!;
			}
		}

		if (Object.keys(setHeaders).length > 0) {
			request = request.clone({ setHeaders });
		}

		return next.handle(request);
	}
}
